import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/root-reducer';
import { AppDispatch } from 'store';
import { MainState } from './main-slice';

export function useMain(): [MainState, AppDispatch] {
  const dispatch = useDispatch<AppDispatch>();
  const state = useSelector((root: RootState) => root.main);
  return [state, dispatch];
}
